/**
 * Route for `ml-based-invalid-traffic-ivt-engine`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { MlBasedInvalidTrafficIvtEnginePage } from "../features/ml-based-invalid-traffic-ivt-engine/MlBasedInvalidTrafficIvtEnginePage";

export const mlBasedInvalidTrafficIvtEngineRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/ml-based-invalid-traffic-ivt-engine",
	component: MlBasedInvalidTrafficIvtEnginePage,
});

export default mlBasedInvalidTrafficIvtEngineRoute;
